module.exports = __webpack_public_path__ + "img/icon1.2426597b.svg";